import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NO_ERRORS_SCHEMA,
  NgZone,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { VehicleService } from '../vdms_core/services/api/vehicle.service';

import { Router } from '@angular/router';
import { DataService } from '../vdms_core/services/vehicle/vehicle.data.services';
import { StringToDateAndRenewalPipe } from '../vdms_shared/pipes/renewal.status';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormControl, Validators } from '@angular/forms';
import { AwsS3BucketService } from '../vdms_core/services/awsS3Bucket/aws-s3-bucket.service';
import { GcsBucketService } from '../vdms_core/services/gcsBucket/gcs.service';

@Component({
  selector: 'app-unassigned-cars',
  templateUrl: './unassigned-cars.component.html',
  styleUrls: ['./unassigned-cars.component.css'],
  providers: [NgxPaginationModule]

})
export class UnassignedCarsComponent {

  @Input() inputUnAssignVehicle: any;
  @Output() viewDetails: EventEmitter<any> = new EventEmitter();

  displayedColumns: string[] = [
    'vehicleNumber',
    'make',
    'model',
    'fuelType',
    'insurance',
    'lease',
    'action',
  ];

  //finduserData: RncUsersModel;
  // Pagination settings
  // pageSizeOptions: number[] = [25, 50, 75, 100];
  // pageSize: number = 25;
  // pageIndex: number = 0;
  // tempData: any;
  activePage: number = 1;
  noOfItems = 10;


  /*************************************************************************
   * FILTER VARIABLE DECLARATION
   ************************************************************************/
  vehicleFilterModel: any = new Array();
  agencyFilterModel: any = new Array();
  carMakeFilterModel: any = new Array();
  carModelFilterModel: any = new Array();
  carFuelFilterModel: any = new Array();
  carTypeFilterModel: any = new Array();
  insuranceFilterModel: any = new Array();
  leaseFilterModel: any = new Array();


  vehicleFilterData: any = [];
  agencyFilterData: any = [];
  carMakeFilterData: any = [];
  carModelFilterData: any = [];
  carFuelFilterData: any = [];
  carTypeFilterData: any = [];
  insuranceFilterData: any = [];
  leaseFilterData: any = [];


  columnfilter = {

    veh_reg_id: {
      singleSelection: false,
      idField: "veh_reg_id",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    angency_name: {
      singleSelection: false,
      idField: "agencyName",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search Agency Name.",
    },
    car_make: {
      singleSelection: false,
      idField: "car_make",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    car_model: {
      singleSelection: false,
      idField: "car_model",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    fuel_type: {
      singleSelection: false,
      idField: "fuel_type",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    car_type: {
      singleSelection: false,
      idField: "car_type",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    policy_no: {
      singleSelection: false,
      idField: "policy_no",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
    lease_to: {
      singleSelection: false,
      idField: "lease_to",
      enableCheckAll: true,
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Search RN ID.",
    },
  }

  sortKey: string = 'veh_reg_id';
  sortReverse: boolean = false;
  filteredVehicles: any = [];  // Filtered vehicles list

  surrenderCarDetails: any;
  filesUploadArray: any = [];
  uploadedSurrenderAttachment: any = [];
  @ViewChild('closeModalBtn') closeModalBtn: ElementRef;
  @ViewChild('uploadFile') uploadFile: ElementRef;
  surrender_date: FormControl = new FormControl('', Validators.required);

  constructor(
    public vehicleService: VehicleService,
    public dataService: DataService,
    public router: Router,
    private cdRef: ChangeDetectorRef,
    private zone: NgZone,
    private stringToDateAndRenewalPipe: StringToDateAndRenewalPipe,
    private awsS3BucketService: AwsS3BucketService,
    public GcsBucketService: GcsBucketService
  ) {
    // this.getunAssignedCars();
  }
  // ngOnInit(): void {
  //   console.log('inputAssignVehicle', this.inputUnAssignVehicle)
  // }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.inputUnAssignVehicle && Array.isArray(changes.inputUnAssignVehicle.currentValue)) {
      console.log('unASSIGNED_CAR', this.inputUnAssignVehicle);
      this.filteredVehicles = [...this.inputUnAssignVehicle];
      console.log('filteredVehicles', this.filteredVehicles)
      this.initializeFilterData(true);
    }
  }


  ngAfterViewInit() {
    if (!this.inputUnAssignVehicle) {
      setTimeout(() => {
        if (Array.isArray(this.inputUnAssignVehicle) && this.inputUnAssignVehicle.length > 0) {
          console.log('UNASSIGNED_CAR', this.inputUnAssignVehicle);
          this.initializeFilterData(true);
        }
      }, 0);
    }
  }

  editRow(mode, record: any) {
    // Edit action
    record.mode = mode
    this.dataService.setRecord(record);
    this.router.navigate(['/pages/addVehicle']);
  }

  viewRow(mode: any, record: any) {
    // Edit action
    console.log('ROW', record);

    // Explicitly define the NavigationExtras to include state
    // const navigationExtras: NavigationExtras = {
    //   state: { record }
    // };
    // this.router.navigate(['/pages/addVehicle'], navigationExtras);
    //this.router.navigate(['/addVehicle'], { state: { record } });

    // Using the service to pass data
    record.mode = mode
    this.dataService.setRecord(record);
    this.router.navigate(['/pages/addVehicle']);
  }

  surrenderedVehicle(mode: any, record: any) {
    record.mode = mode
    this.dataService.setRecord(record);
    this.router.navigate(['/pages/addVehicle']);
  }

  deleteRow(row: any) {
    // Delete action
  }

  /*************************************************************************
   * FILTER FUNCTION DECLARATION
   ************************************************************************/

  private pushIfValid(arr: any[], value: any): void {
    if (value != null && !arr.includes(value)) {
      arr.push(value);
    }
  }

  initializeFilterData(isData: boolean) {
    console.log('initializeFilterData')
    // Clear the filter data arrays

    this.vehicleFilterData = [];
    this.agencyFilterData = [];
    this.carMakeFilterData = [];
    this.carModelFilterData = [];
    this.carFuelFilterData = [];
    this.carTypeFilterData = [];
    this.insuranceFilterData = [];
    this.leaseFilterData = [];

    // const insuranceStatus = this.stringToDateAndRenewalPipe.transform(dSheets.policy_to);
    // const leaseStatus = this.stringToDateAndRenewalPipe.transform(dSheets.lease_to);
    // Populate the filter data arrays
    for (const item of this.inputUnAssignVehicle) {
      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(item.policy_to);
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(item.lease_to);
      console.log('item.fuel_type', item.fuel_type)
      this.pushIfValid(this.vehicleFilterData, item.veh_reg_id);
      this.pushIfValid(this.agencyFilterData, item.agencyName);
      this.pushIfValid(this.carMakeFilterData, item.car_make);
      this.pushIfValid(this.carModelFilterData, item.car_model);
      this.pushIfValid(this.carFuelFilterData, item.fuel_type);
      this.pushIfValid(this.carTypeFilterData, item.car_type);
      this.pushIfValid(this.insuranceFilterData, `${insuranceStatus.status}`);
      this.pushIfValid(this.leaseFilterData, `${leaseStatus.status}`);

    }



    // Update dropdown data with proper change detection
    const updateDropdownData = () => {
      this.vehicleFilterData = [...this.vehicleFilterData];
      this.agencyFilterData = [...this.agencyFilterData];
      this.carMakeFilterData = [...this.carMakeFilterData];
      this.carModelFilterData = [...this.carModelFilterData];
      this.carFuelFilterData = [...this.carFuelFilterData];
      this.carTypeFilterData = [...this.carTypeFilterData];
      this.insuranceFilterData = [...this.insuranceFilterData];
      this.leaseFilterData = [...this.leaseFilterData];

      // this.carMakeFilterData = [...this.carMakeFilterData]; // Ensures array is re-referenced
      // this.carModelFilterData = [...this.carModelFilterData];

      //  this.cdRef.detectChanges(); // Trigger change detection manually if needed
    };

    console.log('carFuelFilterData', this.carFuelFilterData);

    // console.log('filter data added', this.carModelFilterData);

    if (isData) {
      // Update immediately when `isData` is true
      updateDropdownData();
    } else {
      // Use Angular's `zone` to avoid ExpressionChangedAfterItHasBeenCheckedError
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          this.zone.run(() => {
            updateDropdownData();
          });
        }, 15000);
      });
    }
  }


  onFilterChange() {


    const filtered = this.inputUnAssignVehicle.filter(vehicle => {

      const insuranceStatus = this.stringToDateAndRenewalPipe.transform(vehicle.policy_to).status;
      const leaseStatus = this.stringToDateAndRenewalPipe.transform(vehicle.lease_to).status;

      // Helper function to check if a value matches the filter
      const matchesFilter = (filter: any[], value: any) =>
        !filter.length || filter.includes(value);

      // Checking if the vehicle matches all filters
      const matchVehicle = matchesFilter(this.vehicleFilterModel, vehicle.veh_reg_id);
      const matchAgency = matchesFilter(this.agencyFilterModel, vehicle.agencyName);
      const matchCarMake = matchesFilter(this.carMakeFilterModel, vehicle.car_make);
      const matchCarModel = matchesFilter(this.carModelFilterModel, vehicle.car_model);
      const matchCarFuel = matchesFilter(this.carFuelFilterModel, vehicle.fuel_type);
      const matchCarType = matchesFilter(this.carTypeFilterModel, vehicle.car_type);
      const matchInsurance = matchesFilter(this.insuranceFilterModel, insuranceStatus);
      const matchLease = matchesFilter(this.leaseFilterModel, leaseStatus);

      // Return true only if all criteria match
      return (
        matchVehicle &&
        matchAgency &&
        matchCarMake &&
        matchCarModel &&
        matchCarFuel &&
        matchCarType &&
        matchInsurance &&
        matchLease
      );

      // const matchVehicle = !this.vehicleFilterModel.length ||
      //   this.vehicleFilterModel.includes(vehicle.veh_reg_id);
      // const matchCarMake = !this.carMakeFilterModel.length ||
      //   this.carMakeFilterModel.includes(vehicle.car_make);
      // const matchCarModel = !this.carModelFilterModel.length ||
      //   this.carModelFilterModel.includes(vehicle.car_model);
      // const matchDriverName = !this.carFuelFilterModel.length ||
      //   this.carFuelFilterModel.includes(vehicle.car_fuel);
      // const matchCarType = !this.carTypeFilterModel.length ||
      //   this.carTypeFilterModel.includes(vehicle.car_type);
      // const matchInsurance = !this.insuranceFilterModel.length ||
      //   this.insuranceFilterModel.includes(insuranceStatus);
      // const matchLease = !this.leaseFilterModel.length ||
      //   this.leaseFilterModel.includes(leaseStatus);
      // //this.cdRef.detectChanges();
      // return matchVehicle && matchCarMake && matchCarType && matchInsurance && matchLease;
    });

    console.log('filter dont', filtered)
    if (filtered.length === 0) {
      alert('No matching vehicles found!')
    }

    if (filtered.length > 0) {
      this.filteredVehicles = filtered
    }
    // alert('No matching vehicles found!'+this.filteredVehicles.length);
  }

  setsurrenderCarDetails(car: any) {
    this.surrenderCarDetails = car;
  }

  onFileChange(event: any) {
    const files: FileList = event.target.files;

    if (files.length > 0) {
      const file: File = files[0];
      for (let i = 0; i < files.length; i++) {
        this.filesUploadArray.push(this.renamedFileName(files[i], "Vehicle_Surrender"));
      }
      console.log('filesUploadArray', this.filesUploadArray);
    }
  }

  renamedFileName(file: File, namePrefix: string) {
    const vehicleNumber = this.surrenderCarDetails.veh_reg_id;
    const timestamp = new Date().getTime(); // Get current Unix timestamp
    const fileNameParts = file.name.split('.');
    const fileExtension = fileNameParts.pop(); // Extract the file extension
    const renamedFileName = `${namePrefix}_${vehicleNumber}_${timestamp}.${fileExtension}`; // Append timestamp and original file extension to the file name
    const renamedFile = new File([file], renamedFileName, { type: file.type });
    return renamedFile;
  }

  async surrenderCar() {
    if (this.filesUploadArray.length) {
      var urlPath: any;
      var selectedFileObj;
      var inx: any;
      let result: any;
      this.filesUploadArray.forEach((file, index) => {
        selectedFileObj = file;
        inx = index;

        const fileNameParts = file.name.split('_');
        console.log('fileNameParts', fileNameParts);
        const folderName = fileNameParts[0]; // Extract the folder name from the file name
        console.log('folderName', folderName);
        // const awsImagePath
        urlPath = `vdms/${folderName}/${file.name}`;

        console.log('awsImagePath', urlPath);
      });

      try {
        result = await this.GcsBucketService
          .uploadFile(selectedFileObj, urlPath)
          .then((res) => {
            console.log('Upload_success', res);

            console.log('get_key', res.body.bucketPath);

            const urlNameParts = res.body.bucketPath.split('/');
            console.log('urlNameParts', urlNameParts);
            const folderName = urlNameParts[1]; // Extract the folder name from the url name
            console.log('URLName', folderName);

            var obj: any = {
              url: res.body.bucketPath,
              uploaded_on: new Date().toISOString(),
            };
            this.uploadedSurrenderAttachment.push(obj);
            this.filesUploadArray.splice(inx, 1);
            this.surrenderCar();
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      this.saveSurrenderCar();
    }
  }

  async saveSurrenderCar() {
    let surrenderCarObj = {
      id: this.surrenderCarDetails.id,
      surrender_car_attachments: this.uploadedSurrenderAttachment,
      surrender_date: this.surrender_date.value
    }
    this.vehicleService.surrenderVehicle(surrenderCarObj);
    this.closeModal();
  }

  closeModal() {
    this.resetModal();
    this.closeModalBtn.nativeElement.click();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  }

  resetModal() {
    this.surrender_date.reset();
    this.uploadFile.nativeElement.value = null;
    this.filesUploadArray = [];
  }

  viewData(vehicleData: any) {
    this.viewDetails.emit(vehicleData);
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return 'fa fa-sort-desc';
      }
      else {
        return 'fa fa-sort-asc';
      }
    }
    else {
      return 'fa fa-sort';
    }
  }

}
